var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvoicesemptyinline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "No Invoices") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "aacc4706-975d-478c-a53b-dce07bc9be38",
    "data-name": "No Invoices"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#e0e3e4",
    d: "M143.68,101.15a18.66,18.66,0,0,0-18.59,18.69L125,269.32A18.67,18.67,0,0,0,143.59,288h112.2a18.74,18.74,0,0,0,18.68-18.68V165.76a20.64,20.64,0,0,0-6-14.6l-44-44a20.64,20.64,0,0,0-14.59-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c7cdcf",
    d: "M209.87,105.15A16.5,16.5,0,0,1,221.63,110l44,44a16.53,16.53,0,0,1,4.87,11.77V269.32A14.7,14.7,0,0,1,255.79,284H143.59A14.66,14.66,0,0,1,129,269.32l.1-149.48a14.65,14.65,0,0,1,14.59-14.69h66.19m0-4H143.68a18.66,18.66,0,0,0-18.59,18.69L125,269.32A18.67,18.67,0,0,0,143.59,288h112.2a18.74,18.74,0,0,0,18.68-18.68V165.76a20.64,20.64,0,0,0-6-14.6l-44-44a20.64,20.64,0,0,0-14.59-6Z"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 97,
    height: 7,
    x: 151,
    y: 256,
    fill: "#f9f9f9",
    rx: 3.5,
    ry: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 97,
    height: 7,
    x: 151,
    y: 235,
    fill: "#f9f9f9",
    rx: 3.5,
    ry: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 97,
    height: 7,
    x: 151,
    y: 214,
    fill: "#f9f9f9",
    rx: 3.5,
    ry: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 97,
    height: 7,
    x: 151,
    y: 193,
    fill: "#f9f9f9",
    rx: 3.5,
    ry: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f9f9f9",
    d: "M166.16,127.92a2.2,2.2,0,0,1,2.22,2.22v1.14a18.69,18.69,0,0,1,8,2.84,2.74,2.74,0,0,1,1.55,2.47,2.84,2.84,0,0,1-2.89,2.84,3,3,0,0,1-1.55-.46,18.49,18.49,0,0,0-5.32-2.27v9.9c7.85,2,11.2,5.11,11.2,10.63,0,5.68-4.43,9.45-11,10.07v3.09a2.2,2.2,0,0,1-2.22,2.22,2.25,2.25,0,0,1-2.27-2.22v-3.2a22.29,22.29,0,0,1-10.58-4,2.85,2.85,0,0,1-1.39-2.48,2.84,2.84,0,0,1,4.54-2.27,18.3,18.3,0,0,0,7.64,3.46V151.71c-7.54-2-11-4.8-11-10.63,0-5.52,4.39-9.34,10.84-9.85v-1.09A2.25,2.25,0,0,1,166.16,127.92Zm-2.06,17.6v-9.13c-3.3.31-5,2.06-5,4.33S160.12,144.23,164.1,145.52Zm4.07,7.17v9.4c3.31-.37,5.11-2,5.11-4.49C173.28,155.33,172.15,153.93,168.17,152.69Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#c7cdcf",
    d: "M107.5,82H102V76.5a1.5,1.5,0,0,0-3,0V82H93.5a1.5,1.5,0,0,0,0,3H99v5.5a1.5,1.5,0,0,0,3,0V85h5.5a1.5,1.5,0,0,0,0-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c7cdcf",
    d: "M234.5,69H229V63.5a1.5,1.5,0,0,0-3,0V69h-5.5a1.5,1.5,0,0,0,0,3H226v5.5a1.5,1.5,0,0,0,3,0V72h5.5a1.5,1.5,0,0,0,0-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c7cdcf",
    d: "M329.5,131H324v-5.5a1.5,1.5,0,0,0-3,0V131h-5.5a1.5,1.5,0,0,0,0,3H321v5.5a1.5,1.5,0,0,0,3,0V134h5.5a1.5,1.5,0,0,0,0-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c7cdcf",
    d: "M141.12,61.12h-3.24V57.88a.88.88,0,1,0-1.76,0v3.24h-3.24a.88.88,0,1,0,0,1.76h3.24v3.24a.88.88,0,0,0,1.76,0V62.88h3.24a.88.88,0,0,0,0-1.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c7cdcf",
    d: "M303.12,102.12h-3.24V98.88a.88.88,0,0,0-1.76,0v3.24h-3.24a.88.88,0,0,0,0,1.76h3.24v3.24a.88.88,0,0,0,1.76,0v-3.24h3.24a.88.88,0,0,0,0-1.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c7cdcf",
    d: "M78.12,148.12H74.88v-3.24a.88.88,0,0,0-1.76,0v3.24H69.88a.88.88,0,0,0,0,1.76h3.24v3.24a.88.88,0,0,0,1.76,0v-3.24h3.24a.88.88,0,0,0,0-1.76Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoicesemptyinline);
export default __webpack_public_path__ + "static/media/invoices.empty.inline.dcec4a3d.svg";
export { ForwardRef as ReactComponent };